import React from "react";
import styles from "../css/MessageBubble.module.css";
import { format, isValid } from "date-fns";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";

const formatDateTime = (timestamp) => {
  // Handle different timestamp formats and validate
  let date;
  
  if (!timestamp) {
    return ""; // Return empty string for invalid timestamps
  }
  
  // If it's already a Date object
  if (timestamp instanceof Date) {
    date = timestamp;
  }
  // If it's a string (ISO format)
  else if (typeof timestamp === 'string') {
    date = new Date(timestamp);
  }
  // If it's a number (Unix timestamp)
  else if (typeof timestamp === 'number') {
    // Check if it's in seconds or milliseconds
    date = new Date(timestamp > 1000000000000 ? timestamp : timestamp * 1000);
  }
  else {
    date = new Date(timestamp);
  }
  
  // Validate the date before formatting
  if (!isValid(date)) {
    console.warn('Invalid timestamp received:', timestamp);
    return ""; // Return empty string for invalid dates
  }
  
  return format(date, "h:mm a");
};

// MessageBubble Component
const MessageBubble = ({
  message,
  setShowOptionModal,
  setSelectedMsg,
  setShowEdit,
}) => {
  const text = message.body;
  
  // Use timestamp field (normalized in MessagingPage) or fallback to other fields
  const messageTimestamp = message.timestamp || message.sent_at || message.created_at;
  const time = formatDateTime(messageTimestamp);
  
  const userId = JSON.parse(localStorage.getItem("userData"))?.user_id;
  const isNotUser = userId !== message.sender;

  return (
    <div className={`d-flex my-2 mx-2 ${isNotUser ? "" : "flex-row-reverse"}`}>
      <div
        className={`${styles["conversation-image"]} rounded-pill mx-2`}
        style={{
          backgroundImage: `url(${"Image/header/file.svg"})`,
        }}
      ></div>
      <div
        style={{
          maxWidth: "60%",
        }}
      >
        <div
          className={`${
            isNotUser
              ? "rounded-bottom-4 rounded-end-4"
              : "rounded-top-4 rounded-start-4"
          }`}
          style={{
            backgroundColor: isNotUser ? "#fef7f8" : "#d71963",
            color: isNotUser ? "#000" : "#fff",
            display: "flex",
            alignItems: "center",
            gap: "5px",
            padding: "10px 15px",
          }}
        >
          <p className={`${styles["conversation-text"]} fw-bold m-0`}>{text}</p>
          {!isNotUser && (
            <MoreVertRoundedIcon
              sx={{ cursor: "pointer" }}
              onClick={() => {
                setSelectedMsg(message);
                setShowOptionModal(true);
                setShowEdit(true);
              }}
            />
          )}
        </div>
        {time && ( // Only show time if it's valid
          <p
            className={`${styles["conversation-time"]} m-0 mt-1`}
            style={{
              textAlign: isNotUser ? "left" : "right",
            }}
          >
            {time}
          </p>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;